import _ from "lodash";
import { fetch } from "src/services/apollo-fetch";
import { Query } from "./_api";

async function fetchDesigners(data) {
    const response = await fetch.query({
        query: Query.designerSearch,
        variables: data,
    });
    return response.data.designers;
}

export default {
    searchDesigners: _.debounce(
        async (context, search) => {
            return await fetchDesigners({ limit: 50, search });
        },
        500, // 500ms
        { leading: true, trailing: true },
    ),
};
